// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1777":"9f47d5ec","9417":"b2197055"}[chunkId] + ".chunk.css";
};